import { useNavigate } from '@tanstack/react-router';
import { CenteredContentLayout } from '@/components/layout/CenteredContentLayout';
import { PageTitle } from '@/components/layout/PageTitle';
import { PageToolbar } from '@/components/layout/PageToolbar';
import { InstituteForm } from '../components/InstituteForm';
import { useCreateInstitute } from '../hooks/useCreateInstitute';
import type { InstituteFormValues } from '../types/institute.types';
import {
  EMPTY_INSTITUTE_FORM_DEFAULTS,
  buildInstitutePayload,
} from '../utils/instituteFormMappers';

const CREATE_INSTITUTE_TITLE = 'Create Institute';

export function InstituteCreatePage() {
  const navigate = useNavigate();

  function goToList() {
    void navigate({ to: '/settings/institutes' });
  }

  const mutation = useCreateInstitute(goToList);

  function handleSubmit(values: InstituteFormValues) {
    mutation.mutate(buildInstitutePayload(values));
  }

  return (
    <CenteredContentLayout
      header={
        <>
          <PageTitle>{CREATE_INSTITUTE_TITLE}</PageTitle>
          <PageToolbar currentTitle={CREATE_INSTITUTE_TITLE} />
        </>
      }
    >
      <InstituteForm
        defaultValues={EMPTY_INSTITUTE_FORM_DEFAULTS}
        onSubmit={handleSubmit}
        onCancel={goToList}
        isPending={mutation.isPending}
        submitLabel="Create Institute"
        pendingLabel="Creating..."
      />
    </CenteredContentLayout>
  );
}
